import { DefaultFormatRegistry } from '@cs/common';

export class DemoFormatRegistry extends DefaultFormatRegistry {

	constructor() {
		super();
		this.options.nullAsZero = false;
	}
}
